module.exports = __webpack_public_path__ + "static/media/icn-close.5589829f.svg";